jq2 = jQuery.noConflict();
jq2(function() {

  jq2("#clinic_line_item_btn").click(function() {
   var clinicVal = jq2("#clinic").val();
    if(clinicVal.search(/\S/)==-1 || clinicVal =='') {
      jq2("#clinic_label").css("color", "red");
      jq2("#clinic").focus();
      return false;
    } else {
      jq2("#clinic_label").css("color", "black");
    }
    
    if(/[^a-zA-Z0-9\-\s]/g.test(clinicVal)) {
      jq2("#clinic_label").text("Please use only alphanumeric characters, hyphens, and spaces.");
      jq2("#clinic_label").css("color", "red");
      jq2("#clinic").val(clinicVal.replace(/[^a-zA-Z0-9\-\s]/g, ''));
      jq2("#clinic").focus();
      return false;
    } else {
      jq2("#clinic_label").text("Please enter the name of your clinic, and which provider(s) will be referring patients to MaleFromHome");
      jq2("#clinic_label").css("color", "black");
    }

    var trimmedValue = clinicVal.replace(/\s/g, '');
    if(trimmedValue.length < 5) {
      jq2("#clinic_label").text("Please enter at least 5 characters.");
      jq2("#clinic_label").css("color", "red");
      jq2("#clinic").focus();
      return false;
    } else {
      jq2("#clinic_label").text("Please enter the name of your clinic, and which provider(s) will be referring patients to MaleFromHome");
      jq2("#clinic_label").css("color", "black");
    }
    
    const form = jq2("#clinic").closest('form').submit();
    //jq2("#product-form-template--20855903911972__main").submit();
  });
  
  jq2("#open_providers_dialog").on("click", function() {
    jq2("#providers_dialog").dialog({
      modal: true,
      resizable: false,
      dialogClass: "providersdialogbox",
      show: {
        effect: "blind"
      },
      hide: {
        effect: "blind"
      }
    });
  });

  jq2("#providers_name_table").on("click", 'tbody tr td button.select_provider_btn', function() {
    var getDataProviderName = jq2(this).data("provider");
    // If the user selected a "No Provider" option (entries prefixed with '*No Provider'),
    // show a state-specific confirmation before applying the selection.
    if (getDataProviderName && getDataProviderName.match(/^\*No Provider/)) {
      // close the providers dialog while we show the confirmation

      var promptTextHTML = '<p><b>Residents of the State of New York</b>: New York State law requires that laboratory test results be sent to a licensed healthcare provider. If your billing or shipping address is in New York, we may not be able to complete your order without a provider\’s name.</p> <p><b>All other states</b>: You may continue with the option \‘No Provider, just notify me of the results.\’</p> <p>Please confirm your choice or go back to enter your provider\’s information.</p';

      var promptText = "Residents of the State of New York: New York State law requires that laboratory test results be sent to a licensed healthcare provider. If your billing or shipping address is in New York, we may not be able to complete your order without a provider’s name.\n\nAll other states: You may continue with the option ‘No Provider, just notify me of the results.’\n\nPlease confirm your choice or go back to enter your provider’s information.";

      console.log("User selected a 'No Provider' option: " + getDataProviderName);
      jq2("#providers_dialog").dialog('close');
      var $confirmEl = jq2("#no_provider_state_confirmation");
      console.log("#no_provider_state_confirmation exists?", $confirmEl.length);
      // If the markup isn't rendered on this page, create it dynamically so the styled dialog can be shown
      if ($confirmEl.length === 0) {
        console.log('no_provider_state_confirmation missing: creating element dynamically');
        jq2('body').append('<div id="no_provider_state_confirmation" title="Confirm Provider Selection" style="display:none;">' + promptTextHTML + '</div>');
        $confirmEl = jq2('#no_provider_state_confirmation');
      }
      try {
        $confirmEl.dialog({
          resizable: false,
          height: "auto",
          dialogClass: "dobconfirmation",
          modal: true,
          buttons: {
            "Confirm": {
              click: function () {
                // apply the selection as a provider name
                jq2("#ProviderName").val(getDataProviderName);
                jq2(".show_provider_name_outer").show();
                jq2("#show_provider_name").html(getDataProviderName);
                jq2("#open_providers_dialog").hide();
                jq2("#provider_name_error_msg").hide();
                jq2("#provider_name_error_msg").html('');
                jq2(this).dialog("close");
              },
              text: 'Yes, I Confirm',
              class: 'confirm_btn'
            },
            "Cancel": {
              click: function () {
                // user cancelled: reopen the providers dialog so they can choose another option
                jq2(this).dialog("close");
                jq2("#providers_dialog").dialog('open');
              },
              text: 'Back',
              class: 'notconfirm_btn'
            }
          }
        });
        console.log('Opened no_provider_state_confirmation dialog');
      } catch (err) {
        console.error('Failed to open no_provider_state_confirmation dialog', err);
        // Fallback: use a browser confirm so the user still gets the prompt
        var fallback = window.confirm(promptText);
        if (fallback) {
          jq2("#ProviderName").val(getDataProviderName);
          jq2(".show_provider_name_outer").show();
          jq2("#show_provider_name").html(getDataProviderName);
          jq2("#open_providers_dialog").hide();
          jq2("#provider_name_error_msg").hide();
          jq2("#provider_name_error_msg").html('');
        } else {
          // re-open providers dialog
          jq2("#providers_dialog").dialog('open');
        }
      }
      return;
    }
    if(getDataProviderName == '*Other Provider (Enter Below)*') {
      jq2('#no_provider').prop('checked', true);
      jq2('#other_provider_field').show();
      jq2("#provider_name_error_msg").hide();
      jq2("#provider_name_error_msg").html('');
    } else {
      jq2('#no_provider').prop('checked', false);
      jq2('#ProviderNameOther').val('');
      jq2('#other_provider_field').hide();
      jq2("#provider_name_error_msg").hide();
      jq2("#provider_name_error_msg").html('');
      jq2(".no_provider_checkbox").hide();
    }
    jq2("#ProviderName").val(getDataProviderName);
    jq2(".show_provider_name_outer").show();
    jq2("#show_provider_name").html(getDataProviderName);
    jq2("#open_providers_dialog").hide();
    jq2("#providers_dialog").dialog('close');
  });
  
  jq2('#clear_provider_name').click(function() {
    jq2('#ProviderName').val('');
    jq2(".show_provider_name_outer").hide();
    jq2("#open_providers_dialog").show();
    jq2('#no_provider').prop('checked', false);
    jq2('#ProviderNameOther').val('');
    jq2('#other_provider_field').hide();
    jq2(".no_provider_checkbox").show();
  });
  
  jq2("#no_provider").change(function() {
    if(this.checked) {
      jq2('#ProviderName').val('*Other Provider (Enter Below)*');
      jq2(".show_provider_name_outer").show();
      jq2("#show_provider_name").html('*Other Provider (Enter Below)*');
      jq2('#other_provider_field').show();
      jq2("#open_providers_dialog").hide();
      jq2("#provider_name_error_msg").hide();
      jq2("#provider_name_error_msg").html('');
      jq2("#ProviderNameOther").focus();
    } else {
      jq2('#ProviderName').val('');
      jq2(".show_provider_name_outer").hide();
      jq2("#open_providers_dialog").show();
      jq2('#ProviderNameOther').val('');
      jq2('#other_provider_field').hide();
    }
  });

  jq2('.patient_properties .datep input').each(function(){
    var dpInput = jq2(this);
    var dpInputId = dpInput.attr('id');
    var dpParent = jq2(this).parent();
    // Default maxdate of datepicker is 3 months into the future
    //var maxDate = "+3m";
    var maxDate = "+1y";
    //console.log('Converting parent of ' + dpInputId + ' to jquery datepicker.');
    if ( dpInputId.match(/PatientDoB/) ) {
      // Maximum PatientDoB must be at least 16 years ago ...
      maxDate = "-16y";
    }
    jq2(dpInput).datepicker({
      changeYear: true,
      changeMonth: true,
      yearRange: "-100:+100",
      maxDate: maxDate,
      onSelect: function() {
        jq2(this).change();
      }
    });

    jq2(dpInput).attr('readonly','true');
  });
  
  jq2("#open_conditions_dialog").on("click", function() {
    jq2("#conditions_dialog").dialog({
      modal: true,
      resizable: false,
      dialogClass: "conditionsdialogbox",
      show: {
        effect: "blind"
      },
      hide: {
        effect: "blind"
      }
    });
  });
  
  jq2(".cancel_dialog span").on("click", function() {
    jq2("#conditions_dialog").dialog('close');
  });
  
  jq2(".agree_btn_outer span").on("click", function() {
    jq2("#terms_checkbox").prop("checked",true);
    jq2("#conditions_dialog").dialog('close');
  });
  
  jq2("#PatientDoB").on("change", function() {
    
	var GetSelectedDate = new Date(this.value);
    var GetAge = moment().diff(moment(GetSelectedDate, 'MM-DD-YYYY'), 'years');
    //console.log("Years: "+GetAge);
    jq2("#patient_dob_year").text(GetAge);
    
    jq2("#patient_selected_date").text(this.value);
    
    jq2("#dob_confirmation").dialog({
      resizable: false,
      height: "auto",
      show: {
        effect: "blind"
      },
      hide: {
        effect: "blind"
      },
      dialogClass: "dobconfirmation",
      modal: true,
      buttons: {
        "Confirm": {
          click: function () {
            jq2(this).dialog("close");
          },
          text: 'Yes, I Confirm',
          class: 'confirm_btn'
        },
        "Cancel": {
          click: function () {
            jq2("#PatientDoB").val('');
            jq2(this).dialog("close");
          },
          text: 'Back',
          class: 'notconfirm_btn'
        }
      }
    });
    
  });



  jq2("#VasectomyDate").datepicker({
    onSelect: function() {
      jq2(this).change();
    }
  }).on("change", function() {
	var GetSelectedVasectomyDate = new Date(this.value);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    if(GetSelectedVasectomyDate > today) {
    jq2("#vasectomy_selected_date").text(this.value);
    jq2("#vasectomydate_confirmation").dialog({
      resizable: false,
      height: "auto",
      show: {
        effect: "blind"
      },
      hide: {
        effect: "blind"
      },
      dialogClass: "dobconfirmation",
      modal: true,
      buttons: {
        "Confirm": {
          click: function () {
            jq2(this).dialog("close");
          },
          text: 'Yes, I Confirm',
          class: 'confirm_btn'
        },
        "Cancel": {
          click: function () {
            jq2("#VasectomyDate").val('');
            jq2(this).dialog("close");
          },
          text: 'No',
          class: 'notconfirm_btn'
        }
      }
    });
    }
  });
  

  jq2("#product_page_addtocart_btn").click(function() {

    var AvailableKitID = jq2('#KitID').length;
    if(AvailableKitID) {
      var KitIDVal = jq2("#KitID").val();
      if(KitIDVal.search(/\S/)==-1 || checkKitID(KitIDVal) == false) {
        jq2("#kitid_error_msg").show();
        //jq2("#kitid_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please enter 8 digit valid KitID, beginning with a "6".');
        jq2("#kitid_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please enter 8 digit valid KitID.');
        jq2("#KitID").focus();
      	return false;
      } else {
        jq2("#kitid_error_msg").hide();
        jq2("#kitid_error_msg").html('');
      }
    }
    
    var AvailableRegistrationCode = jq2('#RegistrationCode').length;
    if(AvailableRegistrationCode) {
      var RegistrationCodeVal = jq2("#RegistrationCode").val();
      if(RegistrationCodeVal.search(/\S/)==-1 || checkRegCode(RegistrationCodeVal) == false) {
        jq2("#registration_code_error_msg").show();
        jq2("#registration_code_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please enter 6 digit valid registration code.');
        jq2("#RegistrationCode").focus();
      	return false;
      } else {
        jq2("#registration_code_error_msg").hide();
        jq2("#registration_code_error_msg").html('');
      }
    }
    
    var ProviderNameVal = jq2("#ProviderName").val();
      if(ProviderNameVal.search(/\S/)==-1 || ProviderNameVal =='') {
        jq2("#provider_name_error_msg").show();
        jq2("#provider_name_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please select provider from above list.');
      	return false;
      } else {
        jq2("#provider_name_error_msg").hide();
        jq2("#provider_name_error_msg").html('');
      }
    
    if(ProviderNameVal =='*Other Provider (Enter Below)*') {
      if(jq2('#no_provider').is(":checked")) {
        var ProviderNameOtherVal = jq2("#ProviderNameOther").val();
        if(ProviderNameOtherVal.search(/\S/)==-1) {
          jq2("#provider_name_other_error_msg").show();
          jq2("#provider_name_other_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please enter provider\'s name.');
          jq2("#ProviderNameOther").focus();
          return false;
        } else {
          jq2("#provider_name_other_error_msg").hide();
          jq2("#provider_name_other_error_msg").html('');
        }
      }
    }
    
    var NowVasectomyDate = jq2("#VasectomyDate").val();
    if(NowVasectomyDate.search(/\S/)==-1) {
      jq2("#vasectomy_date_error_msg").show();
      jq2("#vasectomy_date_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please select date of vasectomy.');
      jq2("#VasectomyDate").focus();
      return false;
    } else {
      jq2("#vasectomy_date_error_msg").hide();
      jq2("#vasectomy_date_error_msg").html('');
    }
    
    var PatientNameVal = jq2("#PatientName").val();
    if(PatientNameVal.search(/\S/)==-1) {
      jq2("#patient_name_error_msg").show();
      jq2("#patient_name_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please enter patient\'s name.');
      jq2("#PatientName").focus();
      return false;
    } else {
      jq2("#patient_name_error_msg").hide();
      jq2("#patient_name_error_msg").html('');
    }
    
    var NowPatientDoB = jq2("#PatientDoB").val();
    if(NowPatientDoB.search(/\S/)==-1) {
      jq2("#patient_dob_error_msg").show();
      jq2("#patient_dob_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please select patient\'s date of birth.');
      jq2("#PatientDoB").focus();
      return false;
    } else {
      jq2("#patient_dob_error_msg").hide();
      jq2("#patient_dob_error_msg").html('');
    }
    
    var TermsCheckBoxVal = jq2("#terms_checkbox").is(":checked");
    if(!TermsCheckBoxVal) {
      jq2("#terms_checkbox_error_msg").show();
      jq2("#terms_checkbox_error_msg").html('<i class="fa fa-exclamation-circle"></i> Please agree to the terms and conditions.');
      jq2("#terms_checkbox").focus();
      return false;
    } else {
      jq2("#terms_checkbox_error_msg").hide();
      jq2("#terms_checkbox_error_msg").html('');
    }
    jq2("#product_form_id").submit();
    
  });
  
  
});

function checkKitID(KitIDVal)
{  
  // Disable check for "starts with" a '6' (5/14/2024 - rtate)
  //  var pattern = /^(6)[0-9]{7}$/;
    var pattern = /^[0-9]{8}$/;
    if(pattern.test(KitIDVal)){
        return true;
    } else {
        return false;
    }
}

function checkRegCode(RegistrationCodeVal)
{  
    var pattern = /[0-9A-Za-z]{6}/;
    if(pattern.test(RegistrationCodeVal)){
        return true;
    } else {
        return false;
    }
}

